import { Avatar, Box, Typography } from '@mui/material'
import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid-pro'
import { stringAvatar } from 'components/DataGrid/gridOperators'
import { FC } from 'react'
import { Contact, DensityStyleTypes } from 'types'

interface RenderContactNameCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  handleRowClick: (row: GridRenderCellParams) => void
  toggleExpanded: (id: GridRowId) => void // ✅ Fix: Should expect void, not string[]
  contacts: Contact[]
}

const RenderContactNameCell: FC<RenderContactNameCellProps> = ({
  params,
  densityStyles,
  handleRowClick,
  toggleExpanded,
  contacts,
}) => {
  const { rowNode, row: _row, value } = params
  const row = params.row
  const { PK: _PK, isParent } = row
  const contacts_uuid = row?.contacts_uuid
  const isChild = !isParent
  const depth = rowNode?.depth ?? 0
  const indent = depth * 20

  // only parent rows get an expand button
  const isGroup = isParent
  // cast away TS so we can see the internal children array
  const internalNode = rowNode as any
  const hasChildren = (internalNode.children?.length ?? 0) > 0
  const isExpanded = Boolean(internalNode.childrenExpanded)

  const contact = contacts.find(o => o.contacts_uuid === contacts_uuid)
  const _contactName = contact?.name ?? ''
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        pl: isChild ? `${indent}px` : densityStyles.padding,
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleRowClick(row)}
    >
      <>
        {/* parent rows always show expand icon */}
        {/* {isGroup && (
          <IconButton
            size="small"
            disabled={!hasChildren} // gray out if no children
            onClick={e => {
              e.stopPropagation()
              toggleExpanded(params.id)
            }}
            sx={{ color: hasChildren ? 'inherit' : 'text.disabled' }}
          >
            {isExpanded ? (
              <ExpandMoreIcon />
            ) : (
              <ChevronRightIcon sx={{ color: hasChildren ? 'text.primary' : 'text.disabled' }} />
            )}
          </IconButton>
        )} */}

        {/* child-dot only on non-parent rows */}
        {/* {isChild && (
          <FiberManualRecordIcon
            sx={{
              fontSize: 8,
              color: 'text.disabled',
              ml: 1,
              mr: 1,
            }}
          />
        )} */}

        {/* avatar only on parent rows */}
        {isParent &&
          (contact?.photoUrl ? (
            <Avatar
              src={contact.photoUrl}
              sx={{
                width: densityStyles.avatarSize,
                height: densityStyles.avatarSize,
                objectFit: 'cover',
                objectPosition: 'center',
                ml: 1,
              }}
              alt={value}
            />
          ) : (
            <Avatar
              {...stringAvatar(value, densityStyles)}
              sx={{
                backgroundColor: 'rgb(114, 229, 218)',
                width: densityStyles.avatarSize,
                height: densityStyles.avatarSize,
                ml: 1,
              }}
              alt={value}
            />
          ))}

        {/* finally, the row label */}
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontSize: densityStyles.fontSize,
            fontWeight: isParent ? 600 : 400,
            ml: isParent ? 1 : 0,
            color: row?.isOrgTask ? 'text.highlight' : 'text.primary',
          }}
        >
          {value}
        </Typography>
      </>
    </Box>
  )
}

export default RenderContactNameCell
